import React from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';

import useIdleTimer, { IdleTimerViewProps } from './idle-timer.controller';

const ID = 'idle-timer';
export interface IdleTimerProps {
    idleCallback?: () => void;
    modalOverwrite?: (props: IdleTimerViewProps) => React.ReactNode;
}

/**
 * Currently tailored towards mobile (but easily updated to a desktop compatible version)
 * @param props
 * @returns
 */
export const IdleTimer = (props: IdleTimerProps) => {
    const viewProps = useIdleTimer(props);

    if (!viewProps.enabled) return <></>;
    if (viewProps.almostInActive) {
        const root = document.getElementById('app-content');
        if (!root) throw new Error('Root node not found. Cannot render modal.');

        return createPortal(
            props.modalOverwrite ? (
                props.modalOverwrite(viewProps)
            ) : (
                <div
                    onClick={viewProps.onClick}
                    className='modal display-block'
                    aria-modal='true'
                    role='dialog'
                    id={ID}>
                    <div className='modal-mobile-prompt small'>
                        <div className='d-flex flex-column justify-content-center align-items-center fs-5 m-2 text-center'>
                            <span>
                                <FormattedMessage
                                    id='IdleTimer.InactivityMessage'
                                    description='Message displayed on the screen when the user has been inactive for a while.'
                                    defaultMessage='Returning to home screen due to inactivity in {redirectInSeconds} seconds'
                                    values={{ redirectInSeconds: viewProps.timeUntilInactive }}
                                />
                            </span>
                        </div>
                        <div className='modal-footer'>
                            <button
                                onClick={viewProps.onClick}
                                id='stay-active-button'
                                className='btn btn-primary w-100'>
                                <FormattedMessage
                                    id='IdleTimer.StayActive'
                                    description='Button text to stay active on the current screen.'
                                    defaultMessage='Stay active'
                                />
                            </button>
                        </div>
                    </div>
                </div>
            ),
            root
        );
    }
    return <></>;
};

export default IdleTimer;
